import { RtLoaderFn } from "../RtLoader";
import { AbstractFilters, AbstractRow } from "../RtTypes";
import {
  applyRequest,
  ApplyRequestOptions,
} from "./clientDataCtrl/applyRequest";

/**
 * Data source is a static array
 * Filtering is performed on the client. No data modification is expected.
 * @param data Static array
 * @param options filtration rules
 */
export const staticRtLoader =
  <TRow extends AbstractRow, TFilters extends AbstractFilters>(
    data: TRow[],
    options?: ApplyRequestOptions<TRow, TFilters>,
  ): RtLoaderFn<TRow, TFilters> =>
  async (request) =>
    applyRequest(data, request, options);
